import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'router',
  templateUrl: './router.component.html',
  styleUrls: ['./router.component.css']
})
export class RouterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
